import { useState } from 'react';
import { ErrorPage } from '@pages';
import { Loader } from '@components';
import { Stack } from '@mui/material';
import { useRequiredParams } from '@hooks';
import { useForm, useWatch } from 'react-hook-form';
import { useGetCatalogV2 } from '@api';
import { ConfigInfo } from '../../organisms/IntegrationConfigForm/ConfigInfo';
import { IntegrationConfigLayout } from '../../IntegrationConfigForm/layout/IntegrationConfigLayout';
import { IntegrationConfigFormPayload } from '@Integrations/organisms/IntegrationConfigForm/Provider';
import { FormSectionActions } from '../../IntegrationConfigForm/components/FormSection/FormSectionActions';
import { DiscoveryFormSection } from '../../IntegrationConfigForm/organisms/FormSections/DiscoveryFormSection';
import { ConnectorFormSection } from '../../IntegrationConfigForm/organisms/FormSections/ConnectorFormSection';
import { IntegrationConfigFormSection } from '../../IntegrationConfigForm/organisms/FormSections/IntegrationConfigFormSection';

export function ConnectIntegrationGroupForm() {
  const { group } = useRequiredParams(['group']);
  const { integrationsConfigs, isIntegrationsConfigsFetched } = useGetCatalogV2();
  const configs = integrationsConfigs?.filter((c) => c.integrations_group === group);
  const { handleSubmit, control } = useForm<IntegrationConfigFormPayload>({
    mode: 'onSubmit',
  });

  const watch = useWatch({ control });

  const [openSection, setOpenSection] = useState(0);

  const onSubmit = () => {
    // here we will handle the form submit
  };

  const config = configs.length === 1 ? configs[0] : configs.find((c) => c.type === watch.type);

  if (!isIntegrationsConfigsFetched) return <Loader />;

  if (!configs?.length) return <ErrorPage errorCode={404} errorMessage="Integration config not found" />;

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <IntegrationConfigLayout
        sideInfo={<ConfigInfo info={configs[0].info} links={configs[0].links} connectorId={watch.provisioner_id} />}
      >
        <Stack spacing={2}>
          <DiscoveryFormSection
            config={config}
            options={configs}
            control={control}
            expanded={openSection === 0}
            actions={
              <FormSectionActions
                onNextClick={() => setOpenSection(1)}
                nextDisabled={!watch.connected_resource_types?.length}
              />
            }
          />
          <ConnectorFormSection
            config={config ?? configs[0]}
            control={control}
            expanded={openSection === 1}
            actions={
              <FormSectionActions
                onBackClick={() => setOpenSection(0)}
                onNextClick={() => setOpenSection(2)}
                nextDisabled={!watch.provisioner_id?.length}
              />
            }
          />
          <IntegrationConfigFormSection
            config={config ?? configs[0]}
            control={control}
            expanded={openSection === 2}
            actions={
              <FormSectionActions
                onBackClick={() => setOpenSection(1)}
                onNextClick={() => setOpenSection(3)}
                nextDisabled={!watch.name?.length}
              />
            }
          />
        </Stack>
      </IntegrationConfigLayout>
    </form>
  );
}
